import React from 'react';
import { CreatableSelect } from 'react-ocean-forms-bootstrap';
import { ISelectOptions } from "react-ocean-forms-bootstrap";
import { IBaseFieldProps } from 'react-ocean-forms';

interface BasePCCreatableSelectProps {
  name: string;
  label: string;
  createLabel: string;
}

type PCCreatableSelectProps = BasePCCreatableSelectProps & IBaseFieldProps;

/**
 * @author Jungwirth
 */
export const PCCreatableSelect: React.FC<PCCreatableSelectProps> = (props: Readonly<PCCreatableSelectProps>): JSX.Element => {
  const { name, label, createLabel, plaintext, disabled } = props;


  const options: ISelectOptions = [];

  return (
    <React.Fragment>
      <CreatableSelect
        name={name}
        label={label}
        createPrefixLabel={createLabel}
        options={options}
        plaintext={plaintext}
        disabled={disabled}
        
        multi
      />
    </React.Fragment>
  );
};
